import React from "react";
import PropTypes from "prop-types";

class TAppContent extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        appBarHeight: PropTypes.any,
        sideBarWidth: PropTypes.any,
        pageID: PropTypes.string,
        style: PropTypes.object,
    };

    static defaultProps = {
        appBarHeight: "0px",
        sideBarWidth: "300px",
        pageID: "CSHomeForm",
        style: {},
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        let styles = {
            page: {
                transition: "margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1)",
                height: "calc(100% - " + this.props.appBarHeight + "px)",
                //overflowY: 'auto', markChange
                //position: 'absolute', markThomas
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                marginTop: this.props.appBarHeight, // markThomas
                verticalAlign: "top",
                display: "flex",
                ...this.props.style,
            },
            innerPage: {
                margin: this.props.pageID === "CSHomeForm" ? 0 : 20,
            },
        };

        return (
            <div className="AppContent" style={styles.page}>
                {this.props.children ? this.props.children : <div>No children given</div>}
            </div>
        );
    }
}

export default TAppContent;
